var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"button-box"},[_c('el-button',{on:{"click":_vm.print}},[_vm._v("打印")]),_c('el-button',{on:{"click":_vm.download}},[_vm._v("下载")])],1),_c('div',[_c('canvas',{ref:"print",attrs:{"id":"the-canvas"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }